export default {
  english: {
    open: 'Open sharing menu',
    close: 'Close sharing menu',
  },
  french: {
    open: 'Ouvrir le menu de partage',
    close: 'Fermer le menu de partage',
  },
  arabic: {
    open: 'فتح قائمة المشاركة',
    close: 'إغلاق قائمة المشاركة',
  },
  hebrew: {
    open: 'פתח תפריט שיתוף',
    close: 'סגור תפריט שיתוף',
  },
  persian: {
    open: 'منوی اشتراک گذاری را باز کنید',
    close: 'منوی اشتراک گذاری را ببندید',
  },
}
